import { render, staticRenderFns } from "./IconBackspaceOutline.vue?vue&type=template&id=d7d9ba90"
import script from "./IconBackspaceOutline.vue?vue&type=script&lang=js"
export * from "./IconBackspaceOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports